<script>
	import './app.css';
	import Home from './Home.svelte';
  </script>
  
  <main class="app-container">
	<Home />
  </main>
  
  <style>
  </style>
  
  